module.exports = __webpack_public_path__ + "img/Cabin.5e8515b3.png";